import SyncService from '@/services/sync'

function safeParse(raw) {
  if (raw == null || raw === 'undefined') return []
  try {
    const v = JSON.parse(raw)
    return v == null ? [] : v
  } catch (e) {
    return []
  }
}

export default {
  namespaced: true,
  state: {
    pending: JSON.stringify([]),
    conductors: JSON.stringify([]),
    rutas: JSON.stringify([]),
    explotaciones: JSON.stringify([]),
    letraqs: JSON.stringify([]),
    centrorecogidas: JSON.stringify([]),
    explotacionesRuta: JSON.stringify([]),
    explotacionDatos:  JSON.stringify([]),
    explotacionTanques: JSON.stringify([]),
    incidencias: JSON.stringify([]),
    destinos: JSON.stringify([]),
    industrias: JSON.stringify([]),
    nifs: JSON.stringify([]),
    vehiculos: JSON.stringify([]),

    success: null,
    error: null,
  },
  getters: {
    // Defensivo: si el state es undefined/null/empty -> []
    pending: state => safeParse(state.pending),
    conductors: state => safeParse(state.conductors),
    rutas: state => safeParse(state.rutas),
    explotaciones: state => safeParse(state.explotaciones),
    letraqs: state => safeParse(state.letraqs),
    centrorecogidas: state => safeParse(state.centrorecogidas),
    explotacionesRuta: state => safeParse(state.explotacionesRuta),
    explotacionDatos: state => safeParse(state.explotacionDatos),

    explotacionTanques: state => safeParse(state.explotacionTanques),
    incidencias: state => safeParse(state.incidencias),
    destinos: state => safeParse(state.destinos),
    industrias: state => safeParse(state.industrias),
    nifs: state => safeParse(state.nifs),
    vehiculos: state => safeParse(state.vehiculos),



    getRutaConductorUsuario2: (state) =>(id) =>  {
      const rutas = safeParse(state.rutas)
      return rutas.find( item => item.Conductor?.id === id)
    },


    getRutaConductorUsuario : state => (id)=>{
      const rutas = safeParse(state.rutas)
      return rutas.filter((a) => a.Ruta?.id === id)
    },


    getDestinos : state => {

      const destinos =JSON.parse(state.destinos)

      return destinos.filter((a) => {
        return a.id>1;
       // return a.tipo === 'Explotacion' || a.tipo === 'Cisterna'
        // return a.familia === 'Destino Rechazo'
      })
    },
    getMotivosExplotacion : state => {
      // El endpoint /api/incidencias ahora devuelve recogida_motivo_rechazos
      // (tabla unica, sin columna `tipo`). Antes filtrabamos por
      // `tipo === 'Explotacion'`, lo que dejaba el selector vacio. Devolvemos
      // la lista completa: el dominio no distingue motivo de explotacion vs
      // de cisterna; ambos selectores ofrecen la misma lista.
      return JSON.parse(state.incidencias)
    },
    getMotivosCisterna : state => {
      // Misma fuente que getMotivosExplotacion (ver comentario arriba).
      return JSON.parse(state.incidencias)
    },
    getSilos : state => {

      const letraq =JSON.parse(state.letraqs)

      return letraq.filter((a) => {

         return a.tipo === 'Silo'
      })
    },
    getCisternas : state => {
      return safeParse(state.letraqs).filter((a) => a.tipo === 'Cisterna')
    },
    getRemolques : state => {
      return safeParse(state.letraqs).filter((a) => a.tipo === 'Remolque')
    },



  },
  mutations: {


    //const rutaExplotacionCo =computed(() => {return routes.value.filter((t) => t.Ruta.id===ruta.Ruta.id)})

    FILTERED_EXPLOTACION_TANQUES (state,explotacion) {

      const et =JSON.parse(state.explotaciones)
       const filter =et.filter((t) => {return t.id===explotacion})
       const filter2 =et.filter((t) => t.id===explotacion)

       console.log('FILTERED_EXPLOTACION_TANQUES',et,Array.isArray(et),typeof(et),filter,typeof(filter),filter2,typeof(filter2),Object.values(filter)[0]) 

        //SOLO TANQUES state.explotacionTanques =JSON.stringify(Object.values(filter)[0].tanques)
        //EXPLOTACION + TANQUES 
        state.explotacionTanques =JSON.stringify(Object.values(filter)[0])



    },
    
    SET_DATA(state, data) {
      for (const key in data) {
        if (Object.hasOwnProperty.call(state, key)) {
          state[key] = JSON.stringify(data[key])
        }
      }
    
    },
    SET_EXPLOTACIONES(state,data){
      state.explotacionesRuta = JSON.stringify(data)

    },
    SET_EXPLOTACION(state,data){
      state.explotacionDatos = JSON.stringify(data)

    },
    RESET_PENDING(state) {
      state.pending = JSON.stringify([])
    },

    RESET_RUTAS(state) {
      state.rutas = JSON.stringify([])
      console.log('0410 reset rutas',state,state.rutas)
      
    },
    

  },
  actions: {



     deleteData({commit,state }){
      commit('RESET_RUTAS')

      console.log('0410 SYNC delete rutas',state.value)



     },

   /*  FILTERED_EXPLOTACION_TANQUES({commit}, explotacion) {
      commit('FILTERED_EXPLOTACION_TANQUES', explotacion)
    }, */
    async upload({ commit, state }) {
      try {
        commit('SET_LOADING', true, { root: true })

        console.log('upload',commit,state)
       // await SyncService.upload(JSON.parse(state.pending))
       await SyncService.upload(JSON.parse(state.parteDescarga))
        commit('RESET_PENDING')
        //commit('RESET_ENVIO')
        
        commit('SET_SUCCESS', true, { root: true })
      } catch (error) {
        //commit('SET_ERROR', error, { root: true })
        throw error

      } finally {
        commit('SET_LOADING', false, { root: true })
      }
    },
    async download({ commit, dispatch }) {
      try {
        commit('SET_LOADING', true, { root: true })
        dispatch('config/fetch', null, { root: true })
        const data = await SyncService.download()
        commit('SET_DATA', data)
        commit('SET_SUCCESS', true, { root: true })
      } catch (error) {
        throw error
      } finally {
        commit('SET_LOADING', false, { root: true })
      }
    },
    async createCollect({ commit, rootState, state }, collect) {


      console.log('collect-sync',collect)
      try {
        commit('SET_LOADING', true, { root: true })
      //  if (rootState.online) {
          //await SyncService.upload(collect)
       // } else {
          const pending = JSON.parse(state.pending)
          console.log('collect',pending,typeof(pending))
          pending.push(collect)
        
          commit('SET_DATA', { pending })
        //}
        commit('SET_SUCCESS', true, { root: true })
      } catch (error) {
        throw error;
        //commit('SET_ERROR', error, { root: true })
      } finally {
        commit('SET_LOADING', false, { root: true })
      }
    }
  }
}
